import { VueModule } from '@Foundation/utilities';
import BrandContentHub from './code/Scripts/components/brand-content-hub.vue';

export default VueModule({
    components: {
        BrandContentHub
    }
});